import EfBanner from '@elem/ui/ef-banner';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

export default function TheComp() {
    const { locale = 'eu' } = getLocal();
    const IS_UK_SITE = locale === 'uk';
    const { t } = useLang('theProduct.Banner');

    const configs = {
        title: t('title'),
        desc: t('desc'),
        pc: IS_UK_SITE
            ? 'https://websiteoss.ecoflow.com/upload/image/1741153746057/eu-banner-pc.png'
            : 'https://websiteoss.ecoflow.com/upload/image/1741070932221/banner_pc.jpg',
        pad: IS_UK_SITE
            ? 'https://websiteoss.ecoflow.com/upload/image/1741153729878/eu-banner-pad.png'
            : 'https://websiteoss.ecoflow.com/upload/image/1741070932667/banner_pad.jpg',
        h5: IS_UK_SITE
            ? 'https://websiteoss.ecoflow.com/upload/image/1741153729716/eu-banner-h5.png'
            : 'https://websiteoss.ecoflow.com/upload/image/1741070949106/banner_h5.jpg',
        btn_text: t('btn'),
        btn_link: 'https://www.youtube.com/embed/_xbFUQ4b1fQ',
    };

    return (
        <div className={styles.TheComp}>
            <EfBanner {...configs} theme="white" />
        </div>
    );
}
